import styled from 'styled-components';

export const Wrapper = styled.div(({ theme: { size } }) => ({
  height: 'auto',
  paddingRight: size.units(2),
}));
